export const state = {
  // product: undefined,
  // products: []
  attributsexclure: {},
  attributsexclures: [],
  pagination: {
    size: 10,
  },
};
